/**
 * Rubriken över första kolumnen i en estimatkategori.
 *
 * "Arbetsmoment" stämmer för bygg- och sidoentreprenader men blev missvisande
 * i de kategorier som listar något annat: inköp fast inredning innehåller
 * produkter, och baspaketet (inredningsarkitekt) innehåller ritningar.
 *
 * Delas av EstimatCategoryTable (kundvy + kalkyl) och EstimatCategoryEdit
 * (byggkonsultens redigering) så rubriken inte kan säga olika saker beroende
 * på var man tittar.
 */
const RUBRIK_PER_KATEGORI = {
  inkopFastInredning: 'Produkt',
  inredningsarkitekt: 'Ritningar'
};

export const radrubrikFor = (categoryKey) =>
  RUBRIK_PER_KATEGORI[categoryKey] || 'Arbetsmoment';

/**
 * Kort variant för mobil, där kolumnen är smal. Kategorier med egen rubrik
 * behåller den — "Produkt" och "Ritningar" är redan korta nog.
 */
export const radrubrikKortFor = (categoryKey) =>
  RUBRIK_PER_KATEGORI[categoryKey] || 'Moment';

export default radrubrikFor;
